<script setup lang="ts">
import RatioContainer from '~/components/shared/ratioContainer.vue'
import TrackProviderIcon from '~/components/track/providerIcon.vue'
import TrackThumbnailHolder from '~/components/track/thumbnailHolder.vue'

import type { Track } from '~/types/track'

type Props = {
  track?: Partial<Track> | undefined
}
const props = withDefaults(defineProps<Props>(), {
  track: undefined,
})

const mainLink = computed(() => {
  return (
    props.track?.link || props.track?.secondary_link || props.track?.ep_link
  )
})
</script>

<template>
  <div class="previewOuterWrap">
    <RatioContainer :x-aspect="16" :y-aspect="9" class="tw-relative tw-w-full">
      <div class="tw-h-full tw-w-full">
        <TrackThumbnailHolder v-if="track && mainLink" :track-url="mainLink" />
        <TrackProviderIcon :track="track" />
      </div>
    </RatioContainer>
  </div>
</template>

<style scoped lang="scss">
.previewOuterWrap {
  @apply tw-relative tw-w-full tw-overflow-hidden;
  background-color: var(--color-main-dull);
}
</style>
